<vdw-slide-toggle [checked]="checked" label="" [disabled]="true"></vdw-slide-toggle>
